export default defineNuxtPlugin(async () => {
  const userStore = useUserStore();

  if (userStore.authorized) {
    if (import.meta.server) await userStore.loadUser();
    else if (!userStore.loaded) void userStore.loadUser(true);
  }
});
